
  import { defineComponent, PropType } from 'vue';
  import { mapGetters, mapMutations } from 'vuex';
  import axios, { AxiosResponse } from 'axios';

  import FileLocalMultiUploadRedesigned from '@/common/components/redesigned/fileUploads/FileLocalMultiUploadRedesigned.vue';
  import { TUploadingStatus } from '@/common/components/redesigned/uploading-status/types';
  import UploadingPopupStatus from '@/common/components/redesigned/uploading-status/UploadingPopupStatus.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import {
    CALCULATION_COMMON_GETTERS_NAME,
    CALCULATION_COMMON_MUTATIONS_NAME,
  } from '@/modules/ved/store/calculationCommon/name';

  import {
    TCalculationActiveInfo,
    TUploadingDataStatus,
    UploadingDataStatusTypes,
  } from '../../types/calculation-common';
  import { getFileFieldSubtitle } from '../../utils/calculation';
  import CalculationForm from '../common/CalculationForm.vue';
  import CalculationPageWrapper from '../common/CalculationPageWrapper.vue';

  export default defineComponent({
    name: 'AdditionalUploadingTemplate',
    components: {
      CalculationPageWrapper,
      UploadingPopupStatus,
      CalculationForm,
      FileLocalMultiUploadRedesigned,
    },
    mixins: [security],
    props: {
      title: {
        type: String,
        required: true,
      },
      apiUrl: {
        type: String,
        required: true,
      },
      permissionCode: {
        type: Number,
      },
      type: {
        type: Number as PropType<UploadingDataStatusTypes>,
        required: true,
      },
    },
    data(): {
      file: File[];
      isUploadingFile: boolean;
      infoPopupDownloadStatus: TUploadingStatus | null;
    } {
      return {
        file: [],
        isUploadingFile: false,
        infoPopupDownloadStatus: null,
      };
    },
    mounted() {
      this.checkPermissionAndRedirect(this.permissionCode);
    },
    computed: {
      ...mapGetters({
        uploadingDataStatus: CALCULATION_COMMON_GETTERS_NAME.getUploadingDataStatus,
      }),
      getUploadingDataStatus(): TUploadingDataStatus {
        return this.uploadingDataStatus as TUploadingDataStatus;
      },
      FILE_PATH() {
        return 'xlsx';
      },
      getFileSubtitle(): string {
        return getFileFieldSubtitle(this.FILE_PATH);
      },
      getIsFormLoading(): boolean {
        return (
          (this.getUploadingDataStatus.type === this.type && this.getUploadingDataStatus.isProgress) ||
          this.isUploadingFile
        );
      },
    },
    methods: {
      ...mapMutations({
        setUploadingDataStatus: CALCULATION_COMMON_MUTATIONS_NAME.setUploadingDataStatus,
      }),
      async handleSubmitForm() {
        try {
          this.isUploadingFile = true;

          const file = this.file[0];
          if (!file) return;

          const formData = new FormData();
          formData.append('file', file);

          this.infoPopupDownloadStatus = (
            await axios.post<FormData, AxiosResponse<TUploadingStatus>>(this.apiUrl, formData)
          ).data;

          const newUploadingDataStatus: TCalculationActiveInfo = {
            isProgress: true,
            type: this.getType,
          };

          this.setUploadingDataStatus(newUploadingDataStatus);
        } catch (error) {
          console.error(error);
          Constants.alert.fire('Ошибка', 'Не удалось загрузить файл.', 'error');
        } finally {
          this.isUploadingFile = false;
        }
      },
    },
  });
